// extracted by mini-css-extract-plugin
export var container = "_m3-0";
export var dotAnimation = "_m3-2";
export var dotsLoading = "_m3-1";